module.exports = __webpack_public_path__ + "static/img/1.2e30a2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-th/1.jpg
// module id = sRFB
// module chunks = 1